<template>
    <div slot="content">

    </div>
</template>

<script>
export default {
    data() {
        return {
            data: [{test2 : 'test2'}]
        }
    },
    methods: {

    }
}
</script>